package com.devi3east.bashbuddy.di

import com.devi3east.bashbuddy.clientFactory.HttpClientFactory
import io.ktor.client.HttpClient
import org.koin.dsl.module

fun networkModule(factory: HttpClientFactory) = module {

    single<HttpClient> { factory.createHttpClient() }

}